exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".language-selector{vertical-align:top;margin-right:10px}.language-selector img{margin-right:10px;margin-left:-5px;margin-top:-2px}.label-language-icon{margin-right:-6px;position:relative;z-index:1}\n", ""]);

// exports
